import React, { Component } from 'react';
import Meanings from './Meanings';
import { cx } from '@emotion/css';
import * as styles from './questionWithTextFeild.style';
import QuizIndicator from './QuizIndicator';
import withQuizPic from './hoc/withQuizPic';
import { FaKeyboard } from 'react-icons/fa';

class QuestionswithTextField extends Component {
  static specialChars = [
    ['≈', '≠', '±', '≤', '≥','∞', '√', 'θ', 'π', '°', '∝']
  ];

  constructor(props) {
    super(props);
    this.state = {
      value: props.selectedanswer || '',
      quizPic: '',
      showKeyboard: false,
      showmeaning: false,
      meaning: ''
    };

    this.textInput = React.createRef();
    this.keyboardRef = React.createRef();
    this.handleChange = this.handleChange.bind(this);
    this.handleKeypress = this.handleKeypress.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.closemeaningwindow = this.closemeaningwindow.bind(this);
  }

  focus() {
    this.textInput.current.focus();
  }

  closemeaningwindow() {
    // //console.log("Seeting showmeaning to false")
    this.setState({ showmeaning: false });
    this.focus();
  }

  handleKeypress(e) {
    //it triggers by pressing the enter key
    if (e.charCode === 13) {
      this.props.nextbutton();
    }
  }

  handleChange(event) {
    this.setState({ value: event.target.value });
    this.props.selected(event.target.value, '1');
  }

  insertChar = (char) => {
    const input = this.textInput.current;
    if (!input) return;
    
    const start = input.selectionStart;
    const end = input.selectionEnd;
    const newValue = this.state.value.substring(0, start) + char + this.state.value.substring(end);
    
    this.setState(
      { value: newValue },
      () => {
        // Small delay to ensure state is updated
        setTimeout(() => {
          if (this.textInput.current) {
            const newPosition = start + char.length;
            this.textInput.current.focus();
            this.textInput.current.setSelectionRange(newPosition, newPosition);
            this.props.selected(newValue, '1');
          }
        }, 0);
      }
    );
  }

  toggleKeyboard = (e) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    this.setState(prevState => ({
      showKeyboard: !prevState.showKeyboard
    }), () => {
      // Focus back on input after keyboard toggle
      if (this.textInput.current) {
        this.textInput.current.focus();
      }
    });
  };

  selectedanswer = (answer, id) => {
    this.props.selected(answer, id);
  };

  componentDidMount() {
    this.setState({
      quizPic: this.props.getRandomImage(this.props.questionnumber),
    });
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside(event) {
    if (this.keyboardRef.current && !this.keyboardRef.current.contains(event.target) && 
        this.textInput.current && !this.textInput.current.contains(event.target)) {
      this.setState({ showKeyboard: false });
    }
  }

  render() {
    return (
      <div onClick={(e) => e.stopPropagation()}>
        <h2 className={cx(styles.title)}>
          <span>{this.props.questionnumber}/</span>
          {this.props.questionCount}
        </h2>
     
        <img className={cx(styles.img)} src={this.state.quizPic} alt="" />
        <QuizIndicator
          questionCount={this.props.questionCount}
          questionnumber={this.props.questionnumber}
        />
        {this.state.showmeaning && (
          <Meanings
            closewindow={this.closemeaningwindow}
            meaning={this.state.meaning}
          />
        )}

        <div className="">
          <div className={cx(styles.questions)}>{this.props.question}</div>
          <div className={cx(styles.note)}>{this.props.note}</div>

          <div className={cx(styles.answers)}>
            <div className="s-title">Type Answer below </div>
            <div>
              <input
                id={this.props.id}
                type="text"
                value={this.state.value}
                onChange={this.handleChange}
                placeholder="Enter answer here ..."
                spellCheck="false"
                autoComplete="off"
                onKeyPress={this.handleKeypress}
                autoFocus={true}
                ref={this.textInput}
                className={cx(styles.input)}
              />
                <div className={cx(styles.keyboardButtonContainer)}>
                <button 
                  type="button"
                  onClick={this.toggleKeyboard}
                  className={cx(styles.keyboardButton)}
                  title="Toggle Special Characters Keyboard"
                >
                  <FaKeyboard />
                </button>
              </div>
            </div>
            {this.state.showKeyboard && (
              <div 
                ref={this.keyboardRef}
                className={cx(styles.keyboardContainer)}
                onMouseDown={(e) => e.stopPropagation()}
              >
                <div className={cx(styles.keyboardInner)}>
                  {QuestionswithTextField.specialChars.map((row, rowIndex) => (
                    <div key={rowIndex} className={cx(styles.keyboardRow)}>
                      {row.map((char, charIndex) => (
                        <button
                          key={`${rowIndex}-${charIndex}`}
                          type="button"
                          className={cx(styles.charButton)}
                          onMouseDown={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            this.insertChar(char);
                          }}
                        >
                          {char}
                        </button>
                      ))}
                    </div>
                  ))}
                </div>
                <div className={cx(styles.keyboardClose)}>
                  <button 
                    type="button"
                    onMouseDown={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      this.setState({ showKeyboard: false });
                    }}
                    className={cx(styles.closeButton)}
                  >
                    Close
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default withQuizPic(QuestionswithTextField);
